import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { AlertCircle, Loader2 } from 'lucide-react';
import { API_URL } from '../api/config';

export default function DeleteAccount() {
  const [email, setEmail] = useState('');
  const [restaurantId, setRestaurantId] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { signOut, userToken } = useAuth();
  
  const handleDeleteAccount = async () => {
    if (!email || !password || !restaurantId) {
      setError('Please fill in all fields');
      return;
    }
    setError('');
  
    try {
      setLoading(true);
      const response = await axios.post(
       `${API_URL}account/delete`,
        {
          email,
          restaurantId,
          password,
          otp: showOtpInput ? otp : undefined,
        },
        userToken ? {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        } : {} 
      );
  
      if (response.data.success) {
        if (response.data.message === 'OTP sent to your email for account deletion') {
          setShowOtpInput(true);
          setError('');
          alert('OTP sent to your email');
        } else {
          await signOut();
          alert('Account deleted successfully');
          navigate('/login', { replace: true });
        }
      }
    } catch (error) {
      setError(error.response?.data?.message || 'An error occurred during account deletion');
      console.error('Delete account error:', error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="w-full max-w-md space-y-6">
        <h1 className="text-2xl font-bold text-center">Delete Account</h1>
        
        {error && (
          <div className="flex items-center gap-2 p-3 bg-red-100 text-red-700 rounded-md">
            <AlertCircle className="w-5 h-5" />
            <span>{error}</span>
          </div>
        )}

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoCapitalize="none"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Restaurant ID</label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              placeholder="Enter Restaurant ID"
              value={restaurantId}
              onChange={(e) => setRestaurantId(e.target.value)}
              autoCapitalize="none"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <input
              type="password"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {showOtpInput && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">OTP</label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                inputMode="numeric"
              />
            </div>
          )}

          <button
            className={`w-full py-3 px-4 rounded-md font-medium text-white flex items-center justify-center ${
              loading ? 'bg-red-400' : 'bg-red-600 hover:bg-red-700'
            }`}
            onClick={handleDeleteAccount}
            disabled={loading}
          >
            {loading ? (
              <>
                <Loader2 className="animate-spin mr-2" size={18} />
                Deleting...
              </>
            ) : (
              'Delete Account'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}